export default class Client {
    constructor({
        id = 0,
        //provisionId = 0,
        creditFacilitiesId = 0,
        statusId = 0,
        referenceNumber = null,
        //provision = null,
        creditFacility = null,
        loanApplication = null,
        status = null,
        createdAt = new Date(),
        updatedAt = new Date()
    }) 
    {
        this.id = id || 0;
        //this.provisionId = provisionId || 0;
        this.creditFacilitiesId = creditFacilitiesId || 0;
        this.statusId = statusId || 0,
        this.referenceNumber = referenceNumber || null;
        //this.provision = provision || null;
        this.creditFacility = creditFacility || null;
        this.loanApplication = loanApplication || null;
        this.status = status || null;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
}